import I18n from "i18n-js";
import React from "react";

import {
  ActivityIndicator,
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  SafeAreaView,
  Alert
} from "react-native";
import { connect } from "react-redux";
import Markdown from "react-native-markdown-renderer";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";
import { APP_BASE_URL } from "../helpers/storage";
import { API } from "../helpers/axios";

class ConsentScreen extends React.Component {
  state = {
    isLoading: true,
    consent: null,
  };

  async fetchData() {
    try {
      const { patientId, clientId } = this.props.navigation.state.params;

      const {
        data: { data: inboxes },
      } = await API.get(`${APP_BASE_URL}/v1/clients/${clientId}/inboxes`);

      const {
        data: { data: consent },
      } = await API.get(`${APP_BASE_URL}/v2/profile/${patientId}/consent`);

      // execption no inbox in baymax
      if (inboxes.length === 0)
        Alert.alert(
          "Kesalahan",
          "Ada kesalahan pada sistem dokter, harap melaporkan hal ini ke pusat aduan."
        );

      // find DOKTER UMUM inbox
      const inbox = inboxes.find(
        ({ name }) => name.toUpperCase() === "DOKTER UMUM"
      );

      this.setState({
        isLoading: false,
        consent,
        inboxId: inbox.id || inboxes[0].id,
        websiteToken: inbox.website_token || inboxes[0].website_token,
      });
    } catch (error) {
      console.log(error?.response || error);
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  handleCancelPress() {
    this.props.navigation.goBack();
  }

  render() {
    const { themeColors } = this.props;

    let content = null;

    if (this.state.isLoading) {
      content = <ActivityIndicator size="large" color={themeColors.primary} />;
    } else {
      content = (
        <Markdown style={markdownStyles}>{this.state.consent}</Markdown>
      );
    }

    return (
      <View
        style={[styles.container, { backgroundColor: themeColors.primary }]}
      >
        <SafeAreaView>
          <TouchableOpacity
            onPress={() => this.handleCancelPress()}
            style={styles.cancelButton}
          >
            <Image
              source={require("../assets/icons/round_arrow_back_ios_white_18dp.png")}
            />
            <Text style={styles.cancelText}>{I18n.t("prixa.cancel")}</Text>
          </TouchableOpacity>
        </SafeAreaView>
        <View
          style={{
            flexGrow: 1,
            backgroundColor: themeColors.lightestPrimary,
            borderTopEndRadius: 40,
            borderTopStartRadius: 40,
          }}
        >
          <ScrollView style={{ flex: 1 }}>
            <View
              style={{
                padding: 25,
              }}
            >
              <Text
                style={{
                  marginBottom: 5,
                  alignSelf: "center",
                  color: themeColors.darkestPrimary,
                  fontSize: 22,
                  ...fonts.bold,
                }}
              >
                Penjelasan dan Persetujuan
              </Text>
              {content}
            </View>
          </ScrollView>
        </View>
        <View
          style={{
            backgroundColor: "white",
            padding: 25,
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <TouchableOpacity
            style={{
              backgroundColor: "#E64F4F",
              borderRadius: 20,
              paddingVertical: 12,
              paddingHorizontal: 48,
            }}
            onPress={() => this.props.navigation.goBack()}
          >
            <Text
              style={{
                color: "white",
                fontSize: 16,
                ...fonts.bold,
              }}
            >
              Tolak
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={{
              backgroundColor: "#5DBE66",
              borderRadius: 20,
              paddingVertical: 12,
              paddingHorizontal: 48,
            }}
            onPress={() => {
              if (this.state.inboxId && this.state.websiteToken && this.state.consent) {
                this.props.navigation.replace("Waiting", {
                  ...this.props.navigation.state.params,
                  inboxId: this.state.inboxId,
                  websiteToken: this.state.websiteToken,
                  // params passed {
                  //   patientId,
                  //   cardNumberDependency,
                  //   consultation,
                  //   complaintIds,
                  //   duration,
                  //   durationUnit,
                  //   sympthomSummary,
                  //   fullName,
                  //   hasViId,
                  //   enableVoiceCall,
                  //   enableVideoCall,
                  //   clientId,
                  // }
                });
                
              } else Alert.alert("Whoops", "Proses belum selesai, mohon tunggu beberapa saat lagi.");
            }}
          >
            <Text
              style={{
                color: "white",
                fontSize: 16,
                ...fonts.bold,
              }}
            >
              Setuju
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  cancelButton: {
    alignItems: "center",
    flexDirection: "row",
    padding: 15,
  },
  cancelText: {
    color: staticColors.white,
    fontSize: 16,
    marginStart: 15,

    ...fonts.bold,
  },
  container: {
    flex: 1,
  },
});

const markdownStyles = StyleSheet.create({
  text: {
    textAlign: "justify",
  },
  heading: {
    textAlign: "justify",
  },
  bullet_list: {
    textAlign: "justify",
  },
  ordered_list: {
    textAlign: "justify",
  },
  list_item: {
    textAlign: "justify",
  },
});

export default connect((state) => ({
  themeColors: state.themeColors,
}))(ConsentScreen);
